import { atom, PrimitiveAtom } from "jotai";

export const isPrechargeFlowAtom = atom(false);

export const presaleStartDateAtom = atom<string | undefined>(
  undefined
) as PrimitiveAtom<string | undefined>;
